import { lazy } from 'react';
import { authRoles } from 'app/auth';

const DashboardAppConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.user,
	routes: [
		{
			path: '/apps/dashboards',
			component: lazy(() => import('./DashboardApp'))
		}
	]
};

export default DashboardAppConfig;
